import styled from 'styled-components';

import {mixins} from '@edna/components/styles';

export const Row = styled.div`
  ${mixins.f4}
  ${mixins.row}
  gap: ${({theme}) => theme.spacing.s4}
`;
